module.exports = __webpack_public_path__ + "img/43ne.2d08e84a.svg";